import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

API.interceptors.request.use((req) => {
  const adminData = JSON.parse(localStorage.getItem("adminUserData"));
  if (adminData?.token) {
    req.headers.Authorization = `Bearer ${adminData.token}`;
  }
  return req;
});

// Get all blocked domains
export const getBlockedDomains = () =>
  API.get("/admins/blocked-domains");

// Add blocked domain
export const addBlockedDomain = (payload) =>
  API.post("/admins/blocked-domains", payload);

// Delete blocked domain
export const deleteBlockedDomain = (id) =>
  API.delete(`/admins/blocked-domains/${id}`);

export const updateBlockedDomain = (id, payload) =>
  API.put(`/admins/blocked-domains/${id}`, payload);